import Vue from 'vue';
import Transitions from 'vue2-transitions';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/fr';
import VueHtmlToPaper from 'vue-html-to-paper';
// Common lib for login / admin outils
import { ShopAuthManager, ShopSessionManager } from '@holdingblachere/js-sdk';
import { ShopLoginPlugin, AdminLoginPlugin } from '@holdingblachere/vue-common-ui';
import '@holdingblachere/vue-common-ui/dist/mb-vue-common-ui.css';

// Vue Tour
import VueTour from 'vue-tour';
import App from './App.vue';
import router from './router';
import store from './store';
// i18n
import i18n from './i18n/i18n';

// Firebase
import './vendors/firebase/firebase';

// Mixpanel
import mixpanel from './vendors/mixpanel/mixpanel';

require('vue-tour/dist/vue-tour.css');

Vue.prototype.$mixpanel = mixpanel;

Vue.use(VueTour);

Vue.use(Transitions);

Vue.use(ElementUI, { locale });

const shopAuthManager = new ShopAuthManager({
  AMCBackendUrl: process.env.VUE_APP_MON_COMPTE_BACKEND_URL,
});

Vue.use(ShopLoginPlugin, {
  router,
  shopAuthProvider: shopAuthManager,
  store,
});

const shopSessionManager = new ShopSessionManager({
  url: process.env.VUE_APP_SERVER_BASE_URL,
});

Vue.use(AdminLoginPlugin, {
  shopSessionManager,
  afterLoginRoute: 'Dashboard',
  loginWithCustomTokenAction: 'auth/loginWithCustomToken',
});

Vue.config.productionTip = false;

const options = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes',
  ],
  styles: [
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    'https://unpkg.com/kidlat-css/css/kidlat.css',
  ],
};

Vue.use(VueHtmlToPaper, options);

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
